import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { GetCertificateNameByCode } from '../../helpers/Certificates';
import { useCertificateCodes } from './useCertificateCodes';

export const useGetCertificateName = (code: string) => {
  const intl = useIntl();
  const codes = useCertificateCodes();

  const certificateName = useMemo(() => {
    if (codes.result && codes.result?.length > 0) {
      return GetCertificateNameByCode(intl.locale, code, codes.result);
    }
    return '';
  }, [code, codes.result, intl.locale]);

  return certificateName;
};
